import styles from './RelativeKeyBadge.module.css';

interface RelativeKeyBadgeProps {
  root: string;
  quality: 'major' | 'minor';
  onClick?: () => void;
}

export function RelativeKeyBadge({ root, quality, onClick }: RelativeKeyBadgeProps) {
  const label = quality === 'major' ? 'Relative major' : 'Relative minor';
  const name = quality === 'major' ? `${root} Major` : `${root}m`;
  const content = (
    <>
      <span className={styles.label}>{label}: </span>
      <span className={styles.name}>{name}</span>
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        className={styles.container}
        onClick={onClick}
        aria-label={`Switch to ${name}`}
      >
        {content}
      </button>
    );
  }
  return <span className={styles.container}>{content}</span>;
}
